import { render, staticRenderFns } from "./CardTesteGratisXAssinantes.vue?vue&type=template&id=31007f0d&"
import script from "./CardTesteGratisXAssinantes.vue?vue&type=script&lang=js&"
export * from "./CardTesteGratisXAssinantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports